// extracted by mini-css-extract-plugin
export default {"bookInfo":"styles_bookInfo__qzWrs"};